import { fetcher } from '@commenda/utils';
import {
  FilingCalendarGenerateData,
  FilingCalendarGenerateRequest,
  FilingCalendarGenerateResponse,
} from './types';

export interface GenerateFilingCalendarParams {
  corporationId: number;
  state: string;
  filingFrequency: string;
  taxPeriodStartMonth: string; // YYYY-MM format
  taxPeriodEndMonth?: string; // YYYY-MM format
}

export interface GenerateFilingCalendarResult {
  success: boolean;
  data?: FilingCalendarGenerateData;
  error?: string;
}

export async function generateFilingCalendar(
  params: GenerateFilingCalendarParams,
  token?: string
): Promise<GenerateFilingCalendarResult> {
  const {
    corporationId,
    state,
    filingFrequency,
    taxPeriodStartMonth,
    taxPeriodEndMonth,
  } = params;

  const body: FilingCalendarGenerateRequest = {
    corporation_id: corporationId,
    state,
    filing_frequency:
      filingFrequency as FilingCalendarGenerateRequest['filing_frequency'],
    tax_period_start_month: taxPeriodStartMonth,
    ...(taxPeriodEndMonth && { tax_period_end_month: taxPeriodEndMonth }),
  };

  try {
    const response = await fetcher(
      'new-sales-tax/filings/calendar/generate',
      {
        method: 'POST',
        body,
      },
      token
    );

    const responseData: FilingCalendarGenerateResponse = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error:
          (responseData as unknown as { message?: string }).message ||
          'Failed to generate filing calendar',
      };
    }

    return {
      success: true,
      data: responseData.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'An unexpected error occurred while generating the filing calendar',
    };
  }
}
